<template>
  <el-dialog custom-class="carousel-modal" title="图文创意选择" :visible.sync="visible" @open="getList(1)" width="1068px">
    <div class="header-row">
      <div>
        <el-button type="primary" @click="showCreateModal = true">新建图文</el-button>
        <span>&emsp;共{{ pager.total }}个图文</span>
        <span>，已选{{ selectedCarouselIds.length }}个图文</span>
      </div>

      <el-button @click="getList(1)" type="text">刷新</el-button>
    </div>
    <div class="carousel-list" v-loading="listLoading">
      <CarouselItem
        @click.native="onCarouselItemSelect(carousel)"
        :class="selectedCarouselIds.includes(carousel.id) ? 'active' : ''"
        v-for="carousel in carouselList"
        :key="carousel.id"
        :value="carousel"
      />
    </div>
    <div v-if="!carouselList.length" class="carousel-empty">
      暂无图文， <el-button type="text" @click="showCreateModal = true">去新建</el-button>
    </div>
    <div class="modal-footer" slot="footer">
      <el-pagination
        :current-page.sync="pager.pageIndex"
        :page-size.sync="pager.pageSize"
        :total="pager.total"
        @current-change="getList"
        layout="prev, pager, next"
        background
      >
      </el-pagination>
      <div>
        <el-button @click="onCarouselSelectCancel">取 消</el-button>
        <el-button type="primary" :disabled="!selectedCarouselIds.length" @click="onCarouselSelectConfirm">确 定</el-button>
      </div>
    </div>

    <el-dialog title="新建图文" append-to-body :visible.sync="showCreateModal" width="808px">
      <el-form ref="add-form" :model="addForm" :rules="addFormRules" label-width="80px">
        <el-form-item label="图文名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>

        <el-form-item label="图片" prop="images">
          <el-button @click="showImageSelector">选择图片</el-button> <span>{{ addForm.images.length }}/35</span>
          <div class="images-preview">
            <div v-for="img in addForm.images" :key="img.id">
              <em class="remove-icon el-icon-error" @click="removeImage(img)"></em>
              <img :class="img.height > img.width ? 'vertical' : 'horizontal'" :src="img.preview_url" alt="" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="音频">
          <el-button v-if="!addForm.audio.name" @click="showAudioSelector">选择音频</el-button>
          <p v-show="addForm.audio.name">
            <span> {{ addForm.audio.name }}.{{ addForm.audio.source_file_type }}</span>
            <el-button type="text" @click="showAudioSelector">&emsp;修改</el-button>
          </p>
          <p style="font-size: 12px">仅支持mp3、m4a音频格式，如果不上传音频，系统会自动为您匹配选择一段纯音乐</p>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="showCreateModal = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click="onAddConfirm">新建</el-button>
      </div>

      <AssetsSelectorModal :visible.sync="selectorModal" v-bind="selectorProps" @confirm="onSelectorConfirm">
        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]"
          >
            音频
          </el-radio>
        </template>

        <template v-slot:sizes="{ getData }">
          <el-select
            style="width: 120px"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.size"
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelectorModal>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { addCarousel, getCarouselList } from '@/api/toutiao.local.model'
import AssetsSelectorModal, { makeSelectorForm } from '@/components/material-selector/index.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { MATERIAL_TYPE_SIZES } from '@/views/create/gdt/model/creative-const.js'

import CarouselItem from './carousel-item'
const addFormRules = {
  name: [
    { required: true, message: '请输入图文名称', trigger: 'blur' },
    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
  ],
  images: [
    {
      required: true,
      validator: (rule, value, callback) => {
        if (!value.length) {
          return callback(new Error('请选择图片'))
        }
        callback()
      }
    }
  ]
}
export default {
  props: ['value', 'account', 'multipleLimit'],
  components: { AssetsSelectorModal, CarouselItem },
  data() {
    return {
      addLoading: false,
      listLoading: false,
      showCreateModal: false,
      pager: {
        pageIndex: 0,
        pageSize: 12,
        total: 0
      },
      addFormRules,
      carouselList: [],
      selectedCarouselList: [],
      addForm: {
        name: '',
        images: [],
        audio: {}
      },
      MATERIAL_TYPE_SIZES,
      MATERIAL_TYPE_ID,
      MATERIAL_TYPE,
      selectorModal: false,
      selectorProps: {
        max: 35,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: '' }
      }
    }
  },
  computed: {
    // 是否多选
    limit() {
      if (typeof this.multipleLimit === 'number' && this.multipleLimit > 0) {
        return this.multipleLimit
      }
      return 0
    },
    // 已选图文id
    selectedCarouselIds() {
      return this.selectedCarouselList.map((item) => item.id)
    },
    visible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },

  methods: {
    // 确认选择图文弹窗
    onCarouselSelectConfirm() {
      this.$emit('confirm', this.selectedCarouselList)
      this.onCarouselSelectCancel()
    },
    // 关闭选择图文弹窗
    onCarouselSelectCancel() {
      this.visible = false
      this.selectedCarouselList = []
    },

    // 选中图文
    onCarouselItemSelect(carousel) {
      if (this.selectedCarouselIds.includes(carousel.id)) {
        this.selectedCarouselList.splice(this.selectedCarouselIds.indexOf(carousel.id), 1)
      } else {
        this.selectedCarouselList.push(carousel)
      }
      if (this.limit) {
        this.selectedCarouselList = this.selectedCarouselList.slice(-this.limit)
      }
    },
    // 获取图文列表
    getList(page = this.pager.pageIndex) {
      if (this.listLoading) return
      this.listLoading = true
      getCarouselList({ ad_account_id: this.account, page_size: this.pager.pageSize, page })
        .then((data) => {
          const { carousels, page_info } = data
          this.carouselList = carousels
          this.pager.total = page_info.total_count
          this.listLoading = false
          this.pager.pageIndex = page_info.page
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    // 新建图文
    onAddConfirm() {
      this.$refs['add-form'].validate((valid) => {
        if (valid) {
          const params = {
            image_ids: this.addForm.images.map((item) => item.id),
            audio_id: this.addForm.audio.id,
            file_name: this.addForm.name,
            ad_account_id: this.account
          }
          this.addLoading = true
          addCarousel(params)
            .then((data) => {
              this.showCreateModal = false
              this.addLoading = false
              setTimeout(() => {
                this.getList()
              }, 500)
            })
            .catch(() => {
              this.addLoading = false
            })
        }
      })
    },
    // 新建图文时显示图片素材选择框
    showImageSelector() {
      this.selectorProps = {
        max: 35,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE],
        form: { ...makeSelectorForm(), size: '1080*1920' }
      }
      this.selectorModal = true
    },
    // 新建图文时显示音频素材选择框
    showAudioSelector() {
      this.selectorProps = {
        max: 1,
        assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO],
        form: { ...makeSelectorForm(), size: '' }
      }
      this.selectorModal = true
    },
    // 确认选择素材处理
    onSelectorConfirm(assets) {
      const { assetType } = this.selectorProps
      switch (assetType) {
        case MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]:
          this.addForm.images = this.addForm.images.concat(assets).slice(0, 35)
          break
        case MATERIAL_TYPE_ID[MATERIAL_TYPE.AUDIO]:
          this.addForm.audio = assets[0]
          break
        default:
          break
      }

      this.$refs['add-form'].clearValidate()
    },
    removeImage(img) {
      this.addForm.images = this.addForm.images.filter((item) => item.id !== img.id)
    }
  }
}
</script>

<style lang="scss">
.carousel-modal {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
<style lang="scss" scoped>
.modal-footer {
  display: flex;
  justify-content: space-between;
}
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 6px;
}
.images-preview {
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  max-height: 380px;
  overflow: auto;
  > div {
    background: #f3f3f3;
    width: 220px;
    height: 123.75px;
    text-align: center;
    position: relative;
    &:hover {
      .remove-icon {
        display: inline-block;
      }
    }

    .remove-icon {
      display: none;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      font-size: 20px;
      cursor: pointer;
      color: rgb(192, 0, 0);
    }
    .horizontal {
      width: 100%;
    }
    .vertical {
      height: 100%;
    }
  }
}
.carousel-empty {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  line-height: 220px;
  min-height: 220px;
}
.carousel-list {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  max-height: 420px;
  overflow: auto;
}
</style>
